import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  Output,
  Renderer2,
} from '@angular/core';
import { Subject } from 'rxjs';

@Directive({
  selector: '[wzExpandableToggle]',
  standalone: false,
})
export class ExpandableToggleDirective {
  public toggleValue = false;
  @Input()
  set wzExpandableToggle(toggleValue: boolean) {
    this.toggleValue = toggleValue;
  }

  @Output() toggle = new Subject<boolean>();

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
  ) {}

  show() {
    this.renderer.setStyle(this.el.nativeElement, 'display', 'block');
  }

  hide() {
    this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
  }

  @HostListener('click', ['$event'])
  handleClick(_event: Event) {
    this.toggle.next(this.toggleValue);
  }
}
